module.exports = __webpack_public_path__ + "img/downloading-dark.bc8b8c52.svg";